export const basePath = "/";
export const loginPath = "/login";
export const singUpPath = "/singup";
export const recoverPassPath = "/recover_password";
export const verifyEmailPath = "/verify_email";
export const privacyPolicyPath = "/privacy_policy";
export const communityLoginPath = "/login/community";
export const passportPath = "/passport";
export const userSetupPath = "/user_setup";
export const homePath = "/home";
export const userPath = "/userInfo";
export const userPublicationsPath = "/user/publications";
export const userVisitPath = "/user/visit";
export const userSavedPath = "/user/saved";
export const userMemoriesPath = "/user/memories";
export const userConnectionsPath = "/user/connections";
export const userMyEventsPath = "/user/my-events";
// Pestana "Mis guias" del perfil. Solo existe donde el modulo de Guias esta
// encendido (MOSTRAR_GUIAS, declarado mas abajo): en Produccion la pestana no se
// pinta y esta ruta no se registra en AppRouter.
export const userMyGuidesPath = "/user/my-guides";
export const userCourtesyPath = "/user/courtesy";
export const userPassportPath = "/user/passport";
export const settingsPath = "/settings";
export const settingsPersonalPath = "/settings/personal";
export const settingsPrivacyPath = "/settings/privacy";
export const settingsPrivacyBlockPath = "/settings/privacy/block";
export const settingsPrivacySettingsPath = "/settings/privacy/settings";
export const settingsPrivacyPrivacyPath = "/settings/privacy/privacy";
export const settingsPaymentPath = "/settings/payment";
export const settingsPreferencePath = "/settings/preference";
export const settingsSupportPath = "/settings/support";
// export const coWorkingPath = "/co-working";
// export const coWorkingDetailsPath = "/co-working/:idDatosInmuebles";
export const housingPath = "/housing";
export const housingDetailsPath = "/housing/:idDatosInmuebles";
export const culturePath = "/culture";
export const communityPath = "/community";
export const foodPath = "/food";
export const foodPublicationPath = "/food/publication/:id";
export const forumPath = "/forum";
export const forumPublicationPath = "/forum/publication/:id";
export const calmPath = "/calm";
export const courtesyPath = "/courtesy";
export const courtesyDetailPath = "/courtesy/:id";
export const eventsPath = "/events";
// Guias (menu y rutas) solo se encienden si el ambiente lo pide: Pre y Demo
// definen REACT_APP_MOSTRAR_GUIAS=true; Produccion no la define y ahi no existen.
// Mismo patron que REACT_APP_MOSTRAR_VERSION (apagado por omision).
export const MOSTRAR_GUIAS =
  (process.env.REACT_APP_MOSTRAR_GUIAS || "").toLowerCase() === "true";
export const guidesPath = "/guides";
export const guidesProjectPath = "/guides/project";
export const guides2Path = "/guides2";
// La variante va en la ruta porque el contenido se pide por guía Y modalidad
// (obtener/contenido-guia recibe guideVariantTypeCode): sin ella el visor no
// sabría cuál de las dos versiones de la guía abrir.
export const guides2ViewPath = "/guides2/:guideId/:variantTypeCode";
export const buildGuides2ViewPath = (guideId, variantTypeCode) =>
  `/guides2/${guideId}/${variantTypeCode}`;
// VIVA-1214: la liga que se reparte en persona durante el webinar. Es UNA sola y
// no lleva parametros: abre el mismo catalogo de guias que /guides2, con el cobro
// habilitado. No se enlaza desde ninguna navegacion (CA-03).
//
// Convive con la ruta del visor sin poder chocar: React Router v6 no resuelve por
// orden de declaracion sino por puntuacion, y un segmento literal gana al dinamico
// a la misma profundidad. Hoy ademas el visor pide tres segmentos y esto solo dos,
// asi que no compiten. Hay una prueba que fija las dos cosas, porque de ahi depende
// que la liga del webinar abra lo que debe.
export const guides2CheckoutPath = "/guides2/contratar";
export const myEventsPath = "/my-events";
export const createEventPath = "/events/create";
export const editEventPath = "/events/:eventId/edit";
export const mapPath = "/map";
export const chatUserPath = "/chat/user";
export const publicationDetailPath = "/publication/detail";
export const publicationGalleryPath = "/publication/gallery";
export const postWasNotFoundPath = "/postWasNotFound";
export const businessPartner = "/businessPartner/*";
export const idVerificationPath = "/idVerification/*";
export const eventDetailsPath = "/events/:eventId";
export const publicEventDetailsPath = "/public/events/:eventId";
// VIVA-1106: destino del correo de confirmacion de evento virtual (plantilla
// TM0005). El backend arma esta URL con Services:VirtualEventAccessBaseUrl
// apuntando al Front a proposito, no al gateway.
export const virtualEventAccessPath = "/evento-virtual/:token";
export const blogSection = "/blogSection";
export const blogDetail = "/blogSection/:id";
export const AllNoticesPath = "/blogSection/allnotices";
export const businessPropertiesPath = "/businessproperties/*";
export const propertiesPath = "/properties";
export const myPropertiesReservationPath = "/properties/myPropertiesReservation";
export const propertiesEditPath = "/properties/edit";
export const propertiesDashboardPath = "/properties/dashboard";
export const editMyOwnPropertyPath = "/properties/dashboard/edit-property/:idDatosInmuebles"
export const purchaseHistoryPath = "/purchase-history";
export const promotionHistoryPath = "/promotion-history";
export const ratingPath = "/rating";
export const ratingPublicationPath = "/rating/:id";
export const communityStandardsPath = "/community-standards";
export const hashtagPath = "/hashtags";
export const hashtagCategoryPath = "/hashtags/:category";
export const newSideBarPath = "/newSideBar";
export const startMenuPath = "/startMenu";
export const housingPropertiesPath = "/housingProperties";
export const recommendationsPropertiesPath = "/recommendationsProperties";
export const propertyDetailsPath = "/recommendationsProperties/:idProperty";
export const propertyReservationPath = "/propertyReservation/*";
export const applicationsPath = "/applications/:visitId"; 
export const housingApplicationsPath = "/landing/applications"; 
export const brokerVerificationPath = "/broker-verification";     
export const brokerProcessPath = "/broker-verification-process/*"; 
export const brokerProcessPropertiesPath = "/broker-process-properties/*";
export const brokerPropertiesDashboardPath = "/broker-properties-dashboard";
export const brokerPropertiesEditPath = "/broker-properties-edit/:idDatosInmuebles";  
export const verificationPropertiesPath = "/verification-properties-process/*";   
export const brokerLandingPath = "/verification-property";      
// export const pruebaPath = "/prueba";
